var $ = require('jquery');
var _ = require('underscore');
var Configuration = EY.Consultation.Lookups.Configuration;
//var Labels = EY.Consultation.Labels;

var validate = function (options) {
    //var approvers = options.approvers;
    var deferred = $.Deferred();
    //var grouped = _.groupBy(approvers.toJSON(), 'approverGroupId');
    //var groups = options.groups;
    var promise = deferred.promise();
    //var fields = options.fields;
    var record = options.record;

    var validation = record.validation ? _.result(record, "validation") : [];
    var saveValidation = _.clone(validation);

    delete record.validation;
    //extend draft Validation
    record.validation = _.result(record, "draftValidation");

    var valid = record.isValid(true);
  
    //var draftApprovers = approvers.clone().filter(function (approver) {
    //    return approver.get("approverGroupId") === "PartnerInCharge" || approver.get("approverGroupId") === "EngagementQualityReviewer";
    //});
    //_.each(draftApprovers,function (approver) {
    //    var group = approver.get('approverGroupId');
    //    var required = groups.get(group).get('required');
    //    var upn = approver.get('upn');

    //    delete approver.validation.noOfYearsAudited;

    //});
    if (!valid) {
        var $control = $('.required').first();

        if ($control.length && !$control.isInViewport()) {
            $control.parent().children(':first-child').get(0).scrollIntoView();
            $('html').scrollLeft(0);
            $('.record-scroll').scrollLeft(0)
        }
        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
    }
    //restore save validation
    record.validation = function () {
        return saveValidation;
    }
    if (valid) {
        deferred.resolve();
    } 
    return promise;
};

module.exports.run = function (options) {
    return validate(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordDraftValidation.js